import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MPlusIcon from 'shared/icons/buy_with_mplus.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const BuyWithMplus = () => {
  const { t } = useTranslation()
  return (
    <div className={s.buyWithMplus}>
      <p className={clsx(s.text, 'regular-12')}>{t('mplus.buy_with_mplus')}</p>

      <ImageLazy
        src={MPlusIcon}
        alt="mplus icon"
        className={s.icon}
      />
    </div>
  )
}
